import React, { useContext, useEffect, useRef, useState } from "react";
import { TermsOfUseModal } from "modules/auth";
import { AccessibilityStatementModal } from "modules/auth/components/AccessibilityStatementModal";
import { handleKeyDown } from "modules/common/utils/keyboardUtils";
import LogoEU from "../../../../assets/images/LogoEU.png";
import LogoEU_LowVision from "../../../../assets/images/LogoEU_LowVision.png";
import { AccessibilityContext } from "views/AccessibilityContext";

export const MainFooter: React.FC = () => {
    const [showToAModal, setShowToAModal] = useState(false);
    const toggleToAModal = () => {
        setShowToAModal(!showToAModal);
    };
    const [showToUModal, setShowToUModal] = useState(false);
    const toggleToUModal = () => {
        setShowToUModal(!showToUModal);
    };
    const { lowVision } = useContext(AccessibilityContext);
    const logoEU = lowVision ? LogoEU_LowVision : LogoEU;

    const footerRef = useRef<HTMLElement | null>(null);
    const [footerVisible, setFooterVisible] = useState<boolean>(true);

    useEffect(() => {
        const el = footerRef.current;
        if (!el || typeof IntersectionObserver === "undefined") return;

        const observer = new IntersectionObserver(
            entries => {
                setFooterVisible(entries.some(e => e.isIntersecting));
            },
            { root: null, threshold: 0.01 }
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (
        <footer ref={footerRef} className="main-footer container-x">
            <div className={`next-gen${footerVisible ? "" : " next-gen-fixed"}`}>
                <a
                    href="https://next-generation-eu.europa.eu/index_hr"
                    rel="noreferrer"
                    target="_blank"
                >
                    <img src={logoEU} alt="Logo EU" />
                </a>
            </div>
            <span className="main-footer-left">
                <a href="https://poljoprivreda.gov.hr/" rel="noreferrer" target="_blank">
                    Ministarstvo poljoprivrede, šumarstva i ribarstva
                </a>
                <span> {new Date().getFullYear()}. Sva prava pridržana.</span>
            </span>

            <div className="main-footer-middle">
                <a href="https://savjetodavna.mps.hr/" rel="noreferrer" target="_blank">
                    Savjetodavni portal
                </a>
                -
                <a href="https://www.apprrr.hr/" rel="noreferrer" target="_blank">
                    APPRRR
                </a>
                -
                <a href="https://pitanja.mps.hr" rel="noreferrer" target="_blank">
                    Postavi upit
                </a>
                -
                <a href="mailto:pomoc@mps.hr" rel="noopener noreferrer">
                    Pomoć
                </a>
            </div>
            <div className="main-footer-right">
                <a
                    onClick={toggleToAModal}
                    onKeyDown={e => handleKeyDown(e, toggleToAModal)}
                    tabIndex={0}
                >
                    Izjava o pristupačnosti
                </a>
                -
                <a
                    onClick={toggleToUModal}
                    onKeyDown={e => handleKeyDown(e, toggleToUModal)}
                    tabIndex={0}
                >
                    Uvjeti korištenja
                </a>
            </div>

            <AccessibilityStatementModal toggleModal={toggleToAModal} isVisible={showToAModal} />
            <TermsOfUseModal toggleModal={toggleToUModal} isVisible={showToUModal} />
        </footer>
    );
};
